import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCandidateCvByCvId } from "../lib/cvsSlice";
import axios from "axios";
import { useParams } from "react-router";
import Grid from "antd/es/card/Grid";
import * as yup from "yup";

const { REACT_APP_SERVER_URL } = process.env;

const cvIndexQualitySchema = yup.object().shape({
  cvi: yup.number(),

});

const CvQualityIndex = () => {
  const { id } = useParams();
  const cv = useSelector((state) => selectCandidateCvByCvId(state, id));
  const [cvi, setCvi] = useState(null);

  const calculateCvi = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_URL}/cv/getsinglecv/${id}`,

        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      const cvData = response.data;

      if (!cv) {
        return null;
      }

    const currentDate = new Date();
    const threeMonthsAgo = new Date().setMonth(currentDate.getMonth() - 3);
    const sixMonthsAgo = new Date().setMonth(currentDate.getMonth() - 6);

      const targets = {
        summary: 0.15,
        projectExperience: 0.15,
        workExperience: 0.15,
        education: 0.15,
        skills: 0.1,
        techSkills: 0.1,
        toolsCertifications: 0.1,
        updated3Month: 0.1,
        updated4To6Month: 0.05,
        languages: 0.1,
        photo: 0.1,
        testingSkills: 0.1,
      };

      const sectionScores = {
        summary: Math.min(cv.summary.length / 500, 1) * targets.summary,
        projects:
          Math.min(cv.projects.length / 2, 1) * targets.projectExperience,
        workExperience:
          Math.min(cv.experiences.length / 1, 1) * targets.workExperience,
        education:
          Math.min(cv.educations.length / 1, 1) * targets.education,
        skills: Math.min(cv.skills.length / 5, 1) * targets.skills,
        techSkills: Math.min(cv.techSkills.length / 5, 1) * targets.techSkills,
        testingSkills: Math.min(cv.qaSkill.length / 5, 1) * targets.testingSkills,
        languages: Math.min(cv.languages.length / 5, 1) * targets.languages,
        toolsCertifications:
            (Math.min(cv.certifications.length / 5, 1) +
            Math.min(cv.methods.length / 5, 1) +
            Math.min(cv.courses.length / 5, 1)) *
            targets.toolsCertifications,
        updated3Month: cv.lastUpdated && new Date(cv.lastUpdated) > threeMonthsAgo ? targets.updated3Month : 0,
        updated4To6Month: cv.lastUpdated && new Date(cv.lastUpdated) > sixMonthsAgo && new Date(cv.lastUpdated) <= threeMonthsAgo ? targets.updated4To6Month : 0,
        photo: cv.photo ? targets.photo : 0,
      };



    const cvi =
        Object.values(sectionScores).reduce((acc, cur) => acc + cur, 0) * 100;
        setCvi(parseFloat(cvi.toFixed(2)));
        handleSubmit(cvi);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    if (cvi !== null) {
      try {
        await cvIndexQualitySchema.validate({ cvi });
      } catch (error) {
        console.error(error);
        return;
      }
  
      try {
        const response = await axios.post(
          `${REACT_APP_SERVER_URL}/cv/cvi/${id}`,
          {cvi},
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        );
        console.log(response); // handle response data as needed
      } catch (error) {
        console.error(error);
      }
    }
  };
  

  useEffect(() => {
    calculateCvi();
  }, [cv, id]);

  useEffect(() => {
    if (cvi !== null) {
      handleSubmit(cvi);
    }
  }, [cvi]);

  return (
    <Grid>
        {cvi !== null ? `CV Quality Index: ${cvi}%` : "CV Quality Index: 0%"}
    </Grid>
);


};

export default CvQualityIndex;